import React from 'react';

// Renders double-booking warning cards. `onClear(conflict, mode)` where
// mode is 'dismiss_once', 'always_allow', or (admin only) 'defer_to_therapist'.
// `showDefer` adds a "Let therapist decide" button that clears the conflict
// from the admin view while leaving it on the therapist's banner.
export default function ConflictBanner({ conflicts, onClear, showDefer = false }) {
  if (!conflicts || conflicts.length === 0) return null;

  return (
    <div style={{ marginBottom: 20 }}>
      {conflicts.map((c) => {
        const isOverlap = c.kind === 'timeslot_overlap';
        const allowLabel = isOverlap ? 'Always allow this pairing' : 'Always allow this client';
        const headline = isOverlap ? 'Overlapping appointments' : 'Client booked twice this week';

        const lines = isOverlap
          ? c.clients.map((p, i) => (
              <div key={i} style={{ fontSize: 14, marginTop: 2 }}>
                <strong>{p.name}</strong> — {p.time}{p.type ? ` · ${p.type}` : ''}
              </div>
            ))
          : c.appointments.map((a, i) => (
              <div key={i} style={{ fontSize: 14, marginTop: 2 }}>
                <strong>{a.date}</strong>, {a.time} — {a.therapist}
              </div>
            ));

        return (
          <div
            key={`${c.kind}-${c.signature}`}
            style={{
              display: 'flex', alignItems: 'flex-start', gap: 16, flexWrap: 'wrap',
              background: 'linear-gradient(135deg, #7A2E1D 0%, #B5532F 60%, #D98A4F 100%)',
              color: '#fff', borderRadius: 14, padding: '16px 20px', marginBottom: 12,
              boxShadow: '0 6px 20px rgba(122,46,29,0.28)',
            }}
          >
            <div style={{ flex: 1, minWidth: 220 }}>
              <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1.2, textTransform: 'uppercase', opacity: 0.9 }}>
                ⚠️ Possible double booking
              </div>
              <div style={{ fontSize: 18, fontWeight: 700, lineHeight: 1.2, marginTop: 2 }}>
                {isOverlap ? `${headline} — ${c.therapist}` : `${c.client} · ${c.week}`}
              </div>
              <div style={{ marginTop: 8 }}>{lines}</div>
            </div>

            <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
              <button
                onClick={() => onClear(c, 'dismiss_once')}
                style={{
                  background: '#fff', color: '#7A2E1D', border: 'none', borderRadius: 8,
                  padding: '10px 16px', fontWeight: 700, fontSize: 14, cursor: 'pointer',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)', whiteSpace: 'nowrap',
                }}
              >
                Dismiss this one
              </button>
              <button
                onClick={() => onClear(c, 'always_allow')}
                style={{
                  background: 'transparent', color: 'rgba(255,255,255,0.9)',
                  border: '1px solid rgba(255,255,255,0.55)', borderRadius: 8,
                  padding: '10px 14px', fontWeight: 600, fontSize: 14, cursor: 'pointer', whiteSpace: 'nowrap',
                }}
              >
                {allowLabel}
              </button>
              {showDefer && (
                <button
                  onClick={() => onClear(c, 'defer_to_therapist')}
                  style={{
                    background: 'transparent', color: 'rgba(255,255,255,0.9)',
                    border: '1px solid rgba(255,255,255,0.55)', borderRadius: 8,
                    padding: '10px 14px', fontWeight: 600, fontSize: 14, cursor: 'pointer', whiteSpace: 'nowrap',
                  }}
                >
                  Let therapist decide
                </button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
